import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FAQAccordion = ({ items, testPrefix = "faq" }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-navy/10 rounded-2xl border border-navy/10 bg-white" data-testid={`${testPrefix}-accordion`}>
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q}>
            <button
              type="button"
              data-testid={`${testPrefix}-question-${i}`}
              aria-expanded={isOpen}
              aria-controls={`${testPrefix}-answer-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="flex min-h-[56px] w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-base font-bold text-navy-ink transition-colors hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-navy/40 md:px-7"
            >
              {f.q}
              <ChevronDown className={`h-5 w-5 shrink-0 text-gold transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
            </button>
            {isOpen && (
              <p id={`${testPrefix}-answer-${i}`} data-testid={`${testPrefix}-answer-${i}`} className="px-5 pb-5 text-sm leading-relaxed text-slate2 md:px-7 md:text-base">
                {f.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};
